// for wrapped Component
export function getDisplayNameForComponent(prefix, Component) {
  const componentName = Component.displayName || Component.name;

  return componentName ? `${prefix}(${componentName})` : prefix;
}
